import { AppBar } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { Outlet } from "react-router-dom";
import { AppFooter } from "src/components/AppFooter";
import { AppHeader } from "src/components/AppHeader";
import { HideOnScroll } from "src/components/HideOnScroll";
import ScrollToTop from "src/components/ScrollToTop";

export const MainLayout = () => {
  return (
    <>
      <ScrollToTop />

      <Box display="flex" flexDirection="column" alignItems="stretch">
        <HideOnScroll>
          <AppBar style={{
            boxShadow:"initial"
          }} position="fixed" color="darkBg">
            <AppHeader />
          </AppBar>
        </HideOnScroll>

        <Box pt="70px">
          <Outlet />
        </Box>

        <AppFooter />
      </Box>
    </>
  );
};
